export default __webpack_public_path__ + "static/media/D6R.bf5a14d3.jpg";